import { findIndex } from 'lodash'

import i18n from '@/i18n/i18n'
import { DeliveryReminderService } from '@/services/admin/DeliveryReminderService'

import { build_query, errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['remind_date', 'reminder_assignee', 'region', 'script']

export const state = {
  reminders: [],
  reminder: {},
  meta: null,
  stats: []
}

export const mutations = {
  SET_REMINDERS(state, reminders) {
    state.reminders = reminders.data
    state.meta = reminders.meta
  },
  ADD_REMINDERS(state, reminders) {
    state.reminders.push(...reminders.data)
    state.meta = reminders.meta
  },
  CLEAR_REMINDER(state) {
    state.reminder = {}
  },
  SET_REMINDER(state, reminder) {
    state.reminder = reminder
  },
  DELETE_REMINDER(state, reminderToRemove) {
    state.reminders = state.reminders.filter(reminder => {
      return reminder.id !== reminderToRemove.id
    })
  },
  UPDATE_REMINDER(state, reminder) {
    let position = findIndex(state.reminders, r => {
      return r.id === reminder.id
    })

    if (position === -1) {
      return
    }

    let newReminder = {
      ...state.reminders[position],
      ...reminder,
      assignee: reminder.assignee || null
    }

    state.reminders.splice(position, 1, newReminder)
  },
  SET_STATS(state, data) {
    state.stats = data
  }
}

export const actions = {
  getDeliveryReminders({ commit }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise(resolve => {
      let paymentReminderService = new DeliveryReminderService(newQuery)
      paymentReminderService.getDeliveryReminders().then(response => {
        commit('SET_REMINDERS', response)
        resolve(response.data)
      })
    })
  },
  getDeliveryReminder({ commit }, reminderId) {
    return new Promise(resolve => {
      let paymentReminderService = new DeliveryReminderService()
      paymentReminderService.getDeliveryReminder(reminderId).then(response => {
        commit('SET_REMINDER', response.data)
        resolve(response.data)
      })
    })
  },
  loadDeliveryReminders({ commit, state }, query) {
    query.page = state.meta.current_page + 1
    let newQuery = build_query(query, allowedFilters)
    return new Promise(resolve => {
      let paymentReminderService = new DeliveryReminderService(newQuery)
      paymentReminderService.getDeliveryReminders().then(response => {
        commit('ADD_REMINDERS', response)
        resolve(response.data)
      })
    })
  },
  updateDeliveryReminder({ state, dispatch }, reminder) {
    return new Promise((resolve, reject) => {
      let paymentReminderService = new DeliveryReminderService()
      paymentReminderService
        .updateDeliveryReminder(reminder.id, reminder)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.delivery_reminder.confirmation_call')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('views.admin.service_errors.error') + ': ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateReminder({ commit, dispatch }, reminder) {
    commit('UPDATE_REMINDER', reminder)

    if (state.reminder?.id === reminder.id) {
      dispatch('getDeliveryReminder', reminder.id)
    }
  },
  assignOperation({ commit, dispatch }, reminders) {
    return new Promise((resolve, reject) => {
      let deliveryReminderService = new DeliveryReminderService()
      deliveryReminderService
        .assign(reminders)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.assigned', {
              element: t('store.admin.delivery_reminder.delivery_reminders')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('views.admin.service_errors.error') + ': ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getStats({ commit }) {
    return new Promise((resolve, reject) => {
      let deliveryReminderService = new DeliveryReminderService()
      deliveryReminderService
        .stats()
        .then(response => {
          commit('SET_STATS', response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
